var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"girl"},[_c('img',{attrs:{"src":require("../assets/img/girl-and-pet.png"),"alt":"Girl and dog"}})])}
var staticRenderFns = []

export { render, staticRenderFns }